export default "__VITE_ASSET__279eb4a9__"